import React, { Component, useMemo } from 'react';
import Table from "../../../../components/UI/Table/Table";


class ZigramTableView extends Component {

    pepCheckTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("pepCheck")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "pepCheck")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Full Name',
            id: 'fullName',
            accessor: 'fullName'
        },
        {
            Header: 'Country',
            id: 'country',
            accessor: 'country'
        },
        {
            Header: 'Percentage',
            id: 'perScore',
            accessor: 'perScore'
        }
    ];

    indianWatchlistTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("indianWatchlist")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "indianWatchlist")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'List Name',
            id: 'listName',
            accessor: 'listName'
        },
        {
            Header: 'Name Of Associated Company',
            id: 'nameOfAssociatedCompany',
            accessor: 'nameOfAssociatedCompany'
        },
        {
            Header: 'Authority Name',
            id: 'authorityName',
            accessor: 'authorityName'
        },
        {
            Header: 'Name',
            id: 'name',
            accessor: 'name'
        },
        {
            Header: 'Source Link',
            id: 'sourceLink',
            accessor: 'sourceLink'
        },
        {
            Header: 'Fuzzy Score',
            id: 'fuzzyScore',
            accessor: 'fuzzyScore'
        },
        {
            Header: 'Rubix Category',
            id: 'rubixCategory',
            accessor: 'rubixCategory'
        }
    ];

    sanctionCheckTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("sanctionCheck")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "sanctionCheck")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Full Name',
            id: 'fullName',
            accessor: 'fullName'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'Sanction Date',
            id: 'sanctionDate',
            accessor: 'sanctionDate'
        },
        {
            Header: 'Fuzzy Score',
            id: 'fuzzyScore',
            accessor: 'fuzzyScore'
        },
        {
            Header: 'Rubix Category',
            id: 'rubixCategory',
            accessor: 'rubixCategory'
        }
    ];

    apcCheckTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("apcCheck")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "apcCheck")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Published Date',
            id: 'publishedDate',
            accessor: 'publishedDate'
        },
        {
            Header: 'Relevance Score',
            id: 'relevanceScore',
            accessor: 'relevanceScore'
        },
        {
            Header: 'Events',
            id: 'events',
            accessor: 'events'
        },
        {
            Header: 'Source Link',
            id: 'sourceLink',
            accessor: 'sourceLink'
        }
    ];

    usWatchlistTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("unitedStatesWatchlists")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "unitedStatesWatchlists")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'List Name',
            id: 'listName',
            accessor: 'listName'
        },
        {
            Header: 'Full Name',
            id: 'fullName',
            accessor: 'fullName'
        },
        {
            Header: 'Country',
            id: 'country',
            accessor: 'country'
        },
        {
            Header: 'Match Score',
            id: 'matchScore',
            accessor: 'matchScore'
        },
        {
            Header: 'Rubix Category',
            id: 'rubixCategory',
            accessor: 'rubixCategory'
        }
    ];

    ukWatchlistTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("unitedKingdomWatchlists")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "unitedKingdomWatchlists")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Details',
            id: 'details',
            accessor: 'details'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'List Name',
            id: 'listName',
            accessor: 'listName'
        },
        {
            Header: 'Full Name',
            id: 'fullName',
            accessor: 'fullName'
        },
        {
            Header: 'Country',
            id: 'country',
            accessor: 'country'
        },
        {
            Header: 'Match Score',
            id: 'matchScore',
            accessor: 'matchScore'
        },
        {
            Header: 'Rubix Category',
            id: 'rubixCategory',
            accessor: 'rubixCategory'
        }
    ];

    internationalWatchlistTableColumns = [
        {
            Header: (
                <input
                  type="checkbox"
                  style ={{ width: "50px" , height: "20px"}}
                  onClick={(e) => this.props.handleSelectAllChange("internationalWatchlists")}
                  checked={false}
                />
              ),
            id: 'invalid',
            Cell: (p) => <label>
                <input id={p} type="checkbox" style ={{ width: "50px" , height: "20px"}} checked={p.original.caseInvalid} 
                    onClick={(e) => this.props.handleOnChange(e, p.index, "internationalWatchlists")} />
                </label>
        },
        {
            Header: "Entity Name",
            id: 'entityName',
            accessor: 'entityName'
        },
        {
            Header: 'Entity Type',
            id: 'entityType',
            accessor: 'entityType'
        },
        {
            Header: 'Address',
            id: 'address',
            accessor: 'address'
        },
        {
            Header: 'List Name',
            id: 'listName',
            accessor: 'listName'
        },
        {
            Header: 'Details',
            id: 'details',
            accessor: 'details'
        },
        {
            Header: 'Country',
            id: 'country',
            accessor: 'country'
        },
        {
            Header: 'Match Score',
            id: 'matchScore',
            accessor: 'matchScore'
        },
        {
            Header: 'Rubix Category',
            id: 'rubixCategory',
            accessor: 'rubixCategory'
        }
        
    ];

    

    render() {
        var columnsArray = [this.pepCheckTableColumns, this.indianWatchlistTableColumns, this.sanctionCheckTableColumns, this.apcCheckTableColumns, this.usWatchlistTableColumns, this.ukWatchlistTableColumns, this.internationalWatchlistTableColumns];
        const { tasks, columnIndex } = this.props;
        return (
            <Table
            data={this.props.tasks}
            columns={columnsArray[columnIndex]}
            defaultPageSize={10}
            className="CreateCaseModalTable highlight"
            showPagination={true}
            showPaginationTop={false}
            showPaginationBottom={true}
            noDataText="No Cases found"
        />
        )
    }
}

export default ZigramTableView;
